// Maybe look into:
// https://github.com/londomloto/bigtree/blob/master/bigtree.js
// https://github.com/orxtime/nestedsetsjs/blob/master/src/nestedsets.js
// https://github.com/fremail/sequelize-nested-set/blob/a25d463d6be292398e09922a715003f786a413bf/index.js#L1106

export const createTree = (collection, left = 0, right = null) => {
    collection.sort((a, b) => a._lft - b._lft);

    let tree = [];
    collection.forEach((item, i) => {
        if (item._lft === left + 1 && (right === null || item._rgt < right)) {
            if (tree[i] === undefined) tree[i] = {};
            tree[i] = item;

            if (item._rgt - item._lft > 1) {
                const children = createTree(collection, item._lft, item._rgt);
                tree[i].children = children;
            }

            left = item._rgt;
        }
    });

    return tree.filter(el => el !== null);
};

export const hasChildren = element => {
    return element._rgt - element._lft > 1;
};
export const isParent = hasChildren;

export const getChildren = (collection, element) => {
    return collection.filter(el => el._lft > element._lft && el._rgt < element._rgt);
};

export const getAncestors = (collection, element) => {
    return collection.filter(el => el._lft < element._lft && el._rgt > element._rgt)
        .sort((a, b) => (a._lft - a._rgt) - (b._lft - b._rgt));
};

export const addAfter = (collection, target, element) => {
    const rgt = target._rgt;
    collection.forEach(item => {
        if (item._lft > rgt) item._lft += 2;
        if (item._rgt > rgt) item._rgt += 2;
    });

    element._lft = rgt + 1;
    element._rgt = rgt + 2;

    collection.push(element);
    return collection;
};

export const appendTo = (collection, target, element) => {
    let result = [];

    const rgt = target._rgt;
    collection.forEach(el => {
        let item = Object.assign({}, el)
        if (item._lft > rgt) item._lft += 2;
        if (item._rgt >= rgt) item._rgt += 2;
        result.push(item)
    });

    element = Object.assign({}, element)
    element._lft = rgt;
    element._rgt = rgt + 1;

    result.push(element);
    return result;
};

export const append = (collection, element) => {
    let lft = 1;
    let rgt = 2;

    if (collection && collection.length) {
        collection.sort((a, b) => b._rgt - a._rgt);

        const target = collection[0];

        lft = target._rgt + 1;
        rgt = target._rgt + 2;
    }

    element._lft = lft;
    element._rgt = rgt;

    collection.push(element);

    return collection;
};

export const moveBefore = (collection, target, element) => {
    const element_lft = element._lft;
    const element_rgt = element._rgt;

    const target_lft = target._lft;
    const target_rgt = target._rgt;

    const span = element_rgt + 1 - element_lft;
    let distance = target_lft - (element_rgt + 1);

    if (distance > 0) {
        // moving down

        collection.forEach(item => {
            if (item._lft >= element_lft && item._rgt <= element_rgt) {
                // match element and children
                item._lft += distance;
                item._rgt += distance;
            } else if (item._lft > element_rgt && item._rgt < target_lft) {
                // match other moving nodes
                item._lft -= span;
                item._rgt -= span;
            } else if (item._lft < element_lft && item._rgt > element_rgt && target_lft > item._rgt) {
                // match recent parents
                item._rgt -= span;
            } else if (item._lft < target_lft && item._rgt > target_rgt && item._lft > element_lft) {
                // match new parent
                item._lft -= span;
            }
        });
    } else {
        // moving up
        distance = distance + span;
        collection.forEach(item => {
            if (item._lft >= element_lft && item._rgt <= element_rgt) {
                // match element and children
                item._lft += distance;
                item._rgt += distance;
            } else if (item._lft >= target_lft && item._rgt < element_lft) {
                // match target and other moving nodes
                item._lft += span;
                item._rgt += span;
                // if (item._lft === 23) console.log(5);
            } else if (item._lft < element_lft && item._rgt > element_rgt && target_lft <= item._lft) {
                // match recent parents
                item._lft += span;
            } else if (item._lft < target_lft && item._rgt > target_rgt && item._rgt < element_rgt) {
                // match new parent
                item._rgt += span;
            }
        });
    }

    // collection.forEach(item => {
    //     console.log(item.title, item._lft, item._rgt)
    // })
    return collection;
};

export const moveAfter = (collection, target, element) => {
    // check if there are items after the target
    // if so, use the moveBefore method
    // else move element to the very end

    const element_lft = element._lft;
    const element_rgt = element._rgt;

    const target_lft = target._lft;
    const target_rgt = target._rgt;

    const nextItem = collection.find(el => el._lft === target_rgt + 1);
    if (nextItem) {
        return moveBefore(collection, nextItem, element);
    }

    const span = element_rgt + 1 - element_lft;
    let distance = target_rgt - element_rgt;

    if (distance > 0) {
        // moving down
        collection.forEach(item => {
            if (item._lft >= element_lft && item._rgt <= element_rgt) {
                // match element and children
                item._lft += distance;
                item._rgt += distance;
            } else if (item._lft > element_rgt && item._rgt <= target_rgt) {
                // match target and other moving nodes
                item._lft -= span;
                item._rgt -= span;
            } else if (item._lft < element_lft && item._rgt > element_rgt && target_lft > item._rgt) {
                // match recent parents
                item._rgt -= span;
            } else if (item._lft < target_lft && item._rgt > target_rgt && item._lft > element_lft) {
                // match new parent
                item._lft -= span;
            }
        });
    } else {
        // Moving up
        distance = distance + span;
        collection.forEach(item => {
            if (item._lft >= element_lft && item._rgt <= element_rgt) {
                // match element and children
                item._lft += distance;
                item._rgt += distance;
            } else if (item._lft < element_lft && item._rgt > element_rgt && target_rgt < item._lft) {
                // match recent parents
                item._lft += span;
            } else if (item._lft < target_lft && item._rgt > target_rgt) {
                // Match new parent
                item._rgt += span;
            } else if (item._lft < element_rgt && item._lft > target_rgt) {
                // Match moving nodes
                item._lft += span;
                item._rgt += span;
            }
        });
    }

    // collection.forEach(item => {
    //     console.log(item.title, item._lft, item._rgt);
    // });
    return collection;
};

export const moveInto = (collection, target, element) => {
    const element_lft = element._lft;
    const element_rgt = element._rgt;

    const target_lft = target._lft;
    const target_rgt = target._rgt;

    const span = element_rgt + 1 - element_lft;
    let distance = target_rgt - 1 - element_rgt;

    if (target_lft < element_lft && target_rgt > element_rgt) {
        // moving inside own ancestor

        collection.forEach(item => {
            if (item._lft >= element_lft && item._rgt <= element_rgt) {
                // match element and children
                item._lft += distance;
                item._rgt += distance;
            } else if (item._lft > element_rgt && item._rgt < target_lft) {
                // match other moving nodes
                item._lft -= span;
                item._rgt -= span;
            } else if (item._lft < element_lft && item._rgt > element_rgt && target_lft < item._lft) {
                // match recent parents
                item._rgt -= span;
            }
        });
    } else if (distance > 0) {
        // moving down

        collection.forEach(item => {
            if (item._lft >= element_lft && item._rgt <= element_rgt) {
                // match element and children
                item._lft += distance;
                item._rgt += distance;
            } else if (item._lft > element_rgt && item._rgt < target_lft) {
                // match other moving nodes
                item._lft -= span;
                item._rgt -= span;
            } else if (item._lft < element_lft && item._rgt > element_rgt && target_lft > item._rgt) {
                // match recent parents
                item._rgt -= span;
            } else if (item._lft > target_lft && item._rgt < target_rgt) {
                // match new parents children
                item._lft -= span;
                item._rgt -= span;
            } else if (item._lft <= target_lft && item._rgt >= target_rgt && item._lft > element_lft) {
                // match new parent
                item._lft -= span;
            }
        });
    } else {
        // moving up

        distance = distance + span;
        // console.log('>>', element_lft, element_rgt, span, distance);

        collection.forEach(item => {
            if (item._lft >= element_lft && item._rgt <= element_rgt) {
                // match element and children
                item._lft += distance;
                item._rgt += distance;
            } else if (item._lft > target_rgt && item._rgt < element_lft) {
                // match other moving nodes
                item._lft += span;
                item._rgt += span;
            } else if (item._lft < element_lft && item._rgt > element_rgt && target_lft < item._lft) {
                // match recent parents
                item._lft += span;
            } else if (item._lft <= target_lft && item._rgt >= target_rgt && item._rgt < element_rgt) {
                // match new parent
                item._rgt += span;
            }
        });
    }

    // collection.forEach(item => {
    //     console.log(item.title, item._lft, item._rgt)
    // })
    return collection;
};

export const deleteItem = (collection, element) => {
    const span = element._rgt - element._lft + 1;

    const lft = element._lft;
    const rgt = element._rgt;

    collection.forEach(item => {
        if (item._lft >= lft && item._rgt <= rgt) {
            // match deleted elements
            item._lft = 0;
            item._rgt = 0;
            item.deleted = true;
        } else if (lft > 0 && rgt > 0) {
            if (item._lft > rgt) item._lft -= span;
            if (item._rgt > rgt) item._rgt -= span;
        }
    });
    return collection;
};

export const validate = (collection) => {
    const tree = createTree(collection);

    let validIDs = [];
    const walkTheTree = children => {
        children.forEach(item => {
            validIDs.push(item.id);
            if (item.children && item.children.length) {
                walkTheTree(item.children);
            }
        });
    };

    walkTheTree(tree);

    return {
        valid: {
            items: collection.filter(el => validIDs.includes(el.id) === true),
            IDs: validIDs
        },
        invalid: {
            items: collection.filter(el => validIDs.includes(el.id) === false),
            IDs: collection.filter(el => validIDs.includes(el.id) === false).map(el => el.id)
        }
    };
};

export const flattenTree = (tree, left = 0, depth = 0, items = []) => {
    if (tree.length) {
        ++ left;
        let right = left + 1;

        tree.forEach(el => {
            let item = Object.assign({}, el);
            delete item.children

            item._lft = left;
            right = item._lft;

            if (el.children && el.children.length) {
                right = flattenTree(el.children, right, depth + 1, items);
            }

            ++ right;
            left = right + 1;

            item._rgt = right;
            items.push(item);
        })

        if (depth === 0) return items;
        return right;
    }
}

export const fix = (collection) => {
    const tree = createTree(collection);
    return flattenTree(tree)
};

const NestedSet = {
    createTree,
    flattenTree,
    fix,

    isParent,
    hasChildren,
    getChildren,
    getAncestors,

    addAfter,
    appendTo,
    append,
    moveBefore,
    moveAfter,
    moveInto,

    deleteItem,

    validate
};

export default NestedSet;
